/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useT } from 'talkr';
import steps from '../../../survey/steps';
import questions from '../../../survey/questions';
import s from './index.module.scss';
import common from '../../index.module.scss';
import before from './img/before.jpg';
import after from './img/after.jpg';
import beforeMale from './img/before_male.jpg';
import afterMale from './img/after_male.jpg';

function BeforeAfter () {
	const { T } = useT();
	const content = {
		female: {
			review: window.locales.before_after_review,
			review_title: window.locales.before_after_review_title,
			imgBefore: before,
			imgAfter: after,
			weightBefore: window.locales.realPhotoV2_title_female_before,
			weightAfter: window.locales.realPhotoV2_title_female_after,
		},
		male: {
			review: window.locales.before_after_review_male,
			review_title: window.locales.before_after_review_title_male,
			imgBefore: beforeMale,
			imgAfter: afterMale,
			weightBefore: window.locales.realPhotoV2_title_male_before,
			weightAfter: window.locales.realPhotoV2_title_male_after,
		}
	};

	const gender = questions.getAnswers({ questionName: 'gender' }).value;

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'before_after',
			stepStatus: true
		});
	}, []);

	return (
		<div className={common.step}>
			<h1 className={common.stepTitle}>
				{T('before_after')}
			</h1>
			<div className={s.container}>
				<div className={s.imgs}>
					<div className={s.imgWrapper}>
						<img className={s.img} src={content[gender].imgBefore} alt="" />
						<div className={`${s.weight} ${s.before}`}>{content[gender].weightBefore}</div>
					</div>
					<div className={s.imgWrapper}>
						<img className={s.img} src={content[gender].imgAfter} alt="" />
						<div className={`${s.weight} ${s.after}`}>{content[gender].weightAfter}</div>
					</div>
				</div>
				<h2 className={s.subTitle}>{content[gender].review_title}</h2>
				<p className={s.description}>{content[gender].review}</p>
			</div>
		</div>
	);
}

export default BeforeAfter;
